import { Outlet, createFileRoute } from "@tanstack/react-router";

function QuickAccess() {
  return <Outlet />;
}

export const Route = createFileRoute("/_authenticated/app/quick-access")({
  component: QuickAccess,
});
